import { ReactNode } from 'react'
import { Box, IconButton, Typography, Tooltip } from '@mui/material'
import {
  Logout as LogoutIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material'
import { useAuth } from '@/hooks/useAuth'
import { logger } from '@/utils/logger'

interface PluginLayoutProps {
  children: ReactNode
}

const PluginLayout = ({ children }: PluginLayoutProps) => {
  const { user, signOut } = useAuth()

  const handleSignOut = async () => {
    try {
      await signOut()
    } catch (error) {
      logger.error('Sign out failed', error as Error, {
        component: 'PluginLayout'
      })
    }
  }

  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        bgcolor: 'background.default'
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'grey.50'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            component="img"
            src="/logo.png"
            alt="Bridge18"
            sx={{
              width: 28,
              height: 28,
              borderRadius: 0.5
            }}
          />
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 700,
              color: 'primary.main'
            }}
          >
            Bridge18
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Tooltip title="Refresh">
            <IconButton
              size="small"
              onClick={handleRefresh}
              sx={{ color: 'grey.600' }}
            >
              <RefreshIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {user && (
            <Tooltip title={`Sign out (${user.email})`}>
              <IconButton
                size="small"
                onClick={handleSignOut}
                sx={{ color: 'grey.600' }}
              >
                <LogoutIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1, overflow: 'hidden' }}>{children}</Box>
    </Box>
  )
}

export default PluginLayout
